import React, { Component } from 'react';
import './App.css';
import Wizard from './components/Wizard.js';
import AncestryLevelForm from './components/AncestryLevelForm';
import _ from 'lodash';
import 'whatwg-fetch';

class Ancestry extends Component {

    constructor() {
        super();
        this.state = {
            current: 0,
            pages: 1,
            data: {}
        };
        this.storeData = this.storeData.bind(this);
        this.changeLevel = this.changeLevel.bind(this);
        this.changeToLevel = this.changeToLevel.bind(this);
        this.hasValue = this.hasValue.bind(this);
    }

    storeData(id, childid, side, input) {
        let data = _.extend({}, this.state.data);
        if (!data[this.state.current]) data[this.state.current] = {};
        if (!input && data[this.state.current][id]) {
            delete data[this.state.current][id];
        } else {
            data[this.state.current][id] = {
                id: id,
                side: side,
                childid: childid,
                value: input
            };
        }

        if (!data[this.state.current] || !Object.keys(data[this.state.current]).length) {
            delete data[this.state.current];
        }

        this.setState({
            data: data
        });

        // store data in external variable
        let targetObj = document.getElementById(this.props.dataTarget);
        if (targetObj) {
            targetObj.value = JSON.stringify(
                this.state.data
            );
        } else {
            console.log('no dataTarget defined');
        }
    }

    changeLevel(direction) {
        // fetch(this.props.post, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify(
        //         this.state.data
        //     )
        // });

        if (direction === "next") {
            this.setState(function(prev, props) {
                let newCurrent = prev.current + 1;
                let newPages = prev.pages;
                if ((newCurrent + 1) > prev.pages) {
                    newPages++;
                }
                return {
                    current: newCurrent,
                    pages: newPages
                }
            });
        }
        if (direction === "back") {
            this.setState(function(prev, props) {
                return {
                    current: (prev.current - 1)
                }
            });
        }
    }

    changeToLevel(level) {
        this.setState(function(prev, props) {
            return {
                current: level
            }
        });
    }

    hasValue(value) {
        if (!this.state.data[value]) return '';
        if (Object.keys(this.state.data[value]).length > 0) {
            return 'complete';
        }
        return '';
    }

    render() {
        let form_key = "form_key_" + this.state.current;
        if (this.props.post) {
            return (
                <div className="Ancestry">
                    <div className="wizard">
                        <Wizard levels={this.state.pages} key="wizard" current={this.state.current} hasValue={this.hasValue} changeToLevel={this.changeToLevel} />
                    </div>
                    <div className="level-form">
                        <AncestryLevelForm current={this.state.current} key={form_key} data={this.state.data} onInputChange={this.storeData} handleSubmit={this.changeLevel} />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="Ancestry">
                    <h1>Please define post path in global variable "ancestryPostPath"</h1>
                </div>
            );
        }
    }
}

export default Ancestry;



// WEBPACK FOOTER //
// ./src/App.js